import { lazy } from '@loadable/component';

export type { StackedLayoutProps } from './StackedLayout';

export default lazy(() => import('./StackedLayout'));

export { default as StackedLayoutHeader } from './StackedLayoutHeader';
